import BaseComponent from "./BaseComponent";
import Dropdown from "./Dropdown";
import { NodeType } from "../types";

export default class ErrorHandling extends BaseComponent {
    /**
     * Global exception handling
     * @module ErrorHandling
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.state = {
            errorHandling: '',
            moduleOptions: this.getModuleOptions(),
            postProcessingCustomOptions: this.getPostProcessingCustomOptions(),
            returningFromWaitModule: '',
            sessionStart: '',
            userHangUp: ''
        };
    }

    componentDidMount(){
        this.updateUIState();
    }

    setConfig(key, value){
        window.apm.serialized.globalErrorHandling[key] = value;
        this.updateUIState();
        window.apm.serialized.globalErrorHandling.lastLocalChange = window.apm.timestamp;
        window.apm.setSerializedChanged();
    }

    getConfig(key){
        return window.apm.serialized.globalErrorHandling[key];
    }

    getModuleOptions(){
        const modules = window.apm.knowledgeBase.getModules();
        modules.splice(modules[0], 1);
        
        return modules.sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
    }

    getPostProcessingCustomOptions() {
        return window.apm.serialized.components.objects.filter(({_class}) => {
            return _class === NodeType.custom;
        }).map(({name, id}) => {
            return {
                name,
                value: id
            };
        }).sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
    }

    componentWillReceiveProps(_nextProps){
        const moduleOptions = this.getModuleOptions();

        this.setState({'moduleOptions': moduleOptions});  
        this.updateUIState();    
    }

    /**
     * Control the UI (dropdowns) via state
     */
    updateUIState(){
        this.setState({
            errorHandling: this.getConfig("errorHandling"),
            postProcessingCustom: this.getConfig("postProcessingCustom"),
            returningFromWaitModule: this.getConfig("returningFromWaitModule"),
            sessionStart: this.getConfig("sessionStart"),
            userHangUp: this.getConfig("userHangUp")
        });
    }
    
    render(){
        // Dropdown selection states
        const errorHandlingSelected = window.apm.knowledgeBase.getIndexFromValue(this.state.errorHandling, this.state.moduleOptions);
        const postProcessingCustomSelected = window.apm.knowledgeBase.getIndexFromValue(this.state.postProcessingCustom, this.state.postProcessingCustomOptions);
        const returningFromWaitModuleSelected = window.apm.knowledgeBase.getIndexFromValue(this.state.returningFromWaitModule, this.state.moduleOptions);
        const sessionStartSelected = window.apm.knowledgeBase.getIndexFromValue(this.state.sessionStart, this.state.moduleOptions);
        const userHangUpSelected = window.apm.knowledgeBase.getIndexFromValue(this.state.userHangUp, this.state.moduleOptions);
              
        return (
            <div className="row">
                <div className="col-md-6">
                    <Dropdown 
                        label={window.l.settings.post_processing_custom} 
                        tooltip={`Use this to indicate a custom that will execute on completion of every input node. It should be used to adjust the captured intents, particularly for an ASR / HSR value mismatch.`}
                        context={this} 
                        optionName={window.l.settings.post_processing_custom_placeholder}
                        options={this.state.postProcessingCustomOptions} 
                        valKey={"postProcessingCustom"} 
                        selection={postProcessingCustomSelected} 
                        removable={true}
                    />
                </div>
                <div className="col-md-6 col-md-offset-6" />
                <div className="col-md-6">
                    <Dropdown 
                        label={window.l.settings.pre_processing_module} 
                        tooltip={`Use this field if your application executes actions defined in a module each time the user makes an utterance defined in the Global Intent Handling rules, in addition to the Global Intent Handling modules for each utterance type.`}
                        context={this} 
                        optionName={window.l.settings.select_module}
                        options={this.state.moduleOptions} 
                        valKey={"errorHandling"} 
                        selection={errorHandlingSelected} 
                        removable={true}
                    />
                </div>
                <div className="col-md-6">
                    <Dropdown 
                        label={window.l.settings.user_ended_session_module} 
                        tooltip={`Use this field when client requirements dictate that actions must be performed after the caller hangs up. Define these actions in a module and assign it to this field. By default, this field is blank and processing completes at the end of each call.`}
                        context={this}  
                        optionName={window.l.settings.select_module}
                        options={this.state.moduleOptions} 
                        valKey={"userHangUp"} 
                        selection={userHangUpSelected} 
                        removable={true}
                    />
                </div>
                <div className="col-md-6">
                    <Dropdown 
                        label={window.l.settings.session_start_module} 
                        tooltip={"Use this field when the client requirements dictate that actions be performed at the start of each call."}
                        context={this}  
                        optionName={window.l.settings.select_module}
                        options={this.state.moduleOptions} 
                        valKey={"sessionStart"} 
                        selection={sessionStartSelected} 
                        removable={true}
                    />
                </div>
                <div className="col-md-6">
                    <Dropdown 
                        label={window.l.settings.returning_from_wait_module}
                        tooltip="This module is executed when waiting period expires before the customer provides an input with an intent."
                        context={this}  
                        optionName={window.l.settings.select_module}
                        options={this.state.moduleOptions} 
                        valKey={"returningFromWaitModule"} 
                        selection={returningFromWaitModuleSelected} 
                        removable={true}
                    />
                </div>
            </div>
        );
    }
}